module.exports = __webpack_public_path__ + "static/media/luiz-claudio.1cd44e29.png";